import { render, staticRenderFns } from "./StorageOptions.vue?vue&type=template&id=1025cc46"
import script from "./StorageOptions.vue?vue&type=script&lang=js"
export * from "./StorageOptions.vue?vue&type=script&lang=js"
import style0 from "./StorageOptions.vue?vue&type=style&index=0&id=1025cc46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports